import { render, staticRenderFns } from "./WriterPostController.vue?vue&type=template&id=563912df&"
import script from "./WriterPostController.vue?vue&type=script&lang=js&"
export * from "./WriterPostController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports